import React from 'react';
export default function NoResults({ results, noResultsSettings }) {
    var _a, _b, _c;
    const hasRefinements = results.getRefinements().length > 0;
    return (React.createElement("div", { className: "hits-empty-state" },
        React.createElement("p", { className: "hits-empty-state__title" }, ((_a = noResultsSettings.translations) === null || _a === void 0 ? void 0 : _a.noResults) || 'Sorry, we can\'t find any matches to your query!'),
        React.createElement("p", { className: "hits-empty-state__description" }, hasRefinements
            ? (((_b = noResultsSettings.translations) === null || _b === void 0 ? void 0 : _b.refinements) || 'Try to reset your applied filters.')
            : (((_c = noResultsSettings.translations) === null || _c === void 0 ? void 0 : _c.query) || 'Please try another query.'))));
}
